import {gql} from '@apollo/client';

export const sessionMutation = {
    ADD_SESSION: gql`
        #For Adding Session
        mutation AddSession($input: AddSessionModelInput!) {
            addSession(input: $input) {
                id
                token
                user {
                    id
                }
            }
        }
    `,
    ADD_SESSION_WITH_OAUTH: gql`
        #For Adding Session
        mutation AddSessionWithOAuth($token: String!) {
            addSessionWithOAuth(token: $token) {
                email
                firstName
                jwtToken
                lastName
                phoneNumber
                sessionId
                expirey
                userId
            }
        }
    `,
    END_SESSION: gql`
        #For Ending Session
        mutation EndSession($id: UUID!, $sessionStatus: SessionStatus!) {
            endSession(id: $id, sessionStatus: $sessionStatus) {
                statusCode
                message
                success
                data
            }
        }
    `,
};
